var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEllipsisH({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.063 4.875H6.124V.937A.47.47 0 0 0 5.687.5h-.875a.45.45 0 0 0-.437.438v3.937H.437A.45.45 0 0 0 0 5.313v.875c0 .246.191.437.438.437h3.937v3.938c0 .246.191.437.438.437h.875a.45.45 0 0 0 .437-.438V6.626h3.938a.45.45 0 0 0 .437-.438v-.875a.47.47 0 0 0-.438-.437z",
    fill: "#808B9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsisH);
export default __webpack_public_path__ + "static/media/ellipsis-h.bf7c502ff17f2d9e8835524aca97b08e.svg";
export { ForwardRef as ReactComponent };